var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-layout',{attrs:{"navbarTheme":_vm.navBarTheme,"sidebar-theme":"dark"}},[_c('div',{staticClass:"white"},[_c('home-ideas-place-start')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }